export default "/packs/images/loading~000a8094aec3d1e5b3e417e3e5b8ec00.png";